var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1820px",
    height: "1820px",
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FB6340",
    strokeWidth: 100,
    cx: 910,
    cy: 910,
    r: 860
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.736842,534.555556 L470.736842,457 C470.736842,449.820298 476.55714,444 483.736842,444 L1285.52632,444 C1292.70602,444 1298.52632,449.820298 1298.52632,457 L1298.52632,534.555556 C1298.52632,541.735257 1292.70602,547.555556 1285.52632,547.555556 L483.736842,547.555556 C476.55714,547.555556 470.736842,541.735257 470.736842,534.555556 Z M988.105263,1220.66667 L988.105263,1260.44444 C988.105263,1267.07186 982.73268,1272.44444 976.105263,1272.44444 L482.736842,1272.44444 C476.109425,1272.44444 470.736842,1267.07186 470.736842,1260.44444 L470.736842,961.777778 L470.736842,961.777778 L431,961.777778 C424.372583,961.777778 419,956.405195 419,949.777778 L419,858.222222 L419,858.222222 L468.808689,608.981729 C469.929788,603.371795 474.855156,599.333333 480.576014,599.333333 L1288.68714,599.333333 C1294.408,599.333333 1299.33337,603.371795 1300.45447,608.981729 L1334.74211,780.555556 L1334.74211,780.555556 C1298.52632,763.986667 1261.27579,754.666667 1220.92105,754.666667 C1065.71053,754.666667 936.368421,884.111111 936.368421,1039.44444 C936.368421,1098.47111 958.615263,1161.64 988.105263,1220.66667 Z M884.631579,961.777778 L574.210526,961.777778 L574.210526,1168.88889 L884.631579,1168.88889 L884.631579,961.777778 M1402,1039.44444 C1402,1174.06667 1220.92105,1376 1220.92105,1376 C1220.92105,1376 1039.84211,1174.06667 1039.84211,1039.44444 C1039.84211,941.066667 1122.62105,858.222222 1220.92105,858.222222 C1319.22105,858.222222 1402,941.066667 1402,1039.44444 M1283.00526,1044.62222 C1283.00526,1013.55556 1251.96316,982.488889 1220.92105,982.488889 C1189.87895,982.488889 1158.83684,1008.37778 1158.83684,1044.62222 C1158.83684,1075.68889 1184.70526,1106.75556 1220.92105,1106.75556 C1257.13684,1106.75556 1288.17895,1075.68889 1283.00526,1044.62222 Z",
    id: "Shape",
    fill: "#FB6340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.ed44467f239237f5d2851e3c7b0b4a99.svg";
export { ForwardRef as ReactComponent };